/* ============================================================
   PREMIUM GENERAL STORE — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── Header scroll ── */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ── Announcement bar close ── */
  const announceClose = document.querySelector('.announcement-bar__close');
  const announceBar = document.getElementById('announcement-bar');
  if (announceClose && announceBar) {
    announceClose.addEventListener('click', () => {
      announceBar.style.height = announceBar.offsetHeight + 'px';
      requestAnimationFrame(() => {
        announceBar.style.transition = 'height 0.3s ease, opacity 0.3s ease';
        announceBar.style.height = '0';
        announceBar.style.opacity = '0';
        announceBar.style.overflow = 'hidden';
        setTimeout(() => announceBar.remove(), 350);
      });
    });
  }

  /* ── Mobile nav toggle ── */
  const navToggle = document.getElementById('nav-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ── Search Modal ── */
  const searchModal = document.getElementById('search-modal');
  const searchToggle = document.getElementById('search-toggle');
  const searchClose = document.getElementById('search-close');
  const searchOverlay = document.getElementById('search-overlay');

  function openSearch() {
    if (!searchModal) return;
    searchModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const input = searchModal.querySelector('.search-modal__input');
    if (input) setTimeout(() => input.focus(), 100);
  }
  function closeSearch() {
    if (!searchModal) return;
    searchModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);

  /* ── Cart Drawer ── */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartToggle = document.getElementById('cart-toggle');
  const cartClose = document.getElementById('cart-close');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartCount = document.getElementById('cart-count');
  const cartBody = document.getElementById('cart-body');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  async function refreshCart() {
    if (!cartBody) return;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartUI(cart);
    } catch (err) {
      console.warn('Cart fetch error:', err);
    }
  }

  function updateCartUI(cart) {
    if (!cartBody || !cartCount) return;
    cartCount.textContent = cart.item_count;

    if (cart.item_count === 0) {
      cartBody.innerHTML = '<p class="cart-drawer__empty">Your cart is empty. <a href="/collections/all" style="color:var(--color-primary);font-weight:600;">Start shopping</a></p>';
      return;
    }

    cartBody.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}" style="display:flex;gap:1rem;margin-bottom:1.25rem;padding-bottom:1.25rem;border-bottom:1px solid var(--color-border);">
        <a href="${item.url}" style="flex-shrink:0;">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" style="width:72px;height:72px;object-fit:cover;border-radius:8px;">` : `<div style="width:72px;height:72px;border-radius:8px;background:var(--color-bg-alt);"></div>`}
        </a>
        <div style="flex:1;min-width:0;">
          <a href="${item.url}" style="font-weight:600;font-size:0.9rem;display:block;margin-bottom:0.25rem;">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-size:0.8rem;color:var(--color-text-muted);">${item.variant_title}</p>` : ''}
          <div style="display:flex;align-items:center;justify-content:space-between;margin-top:0.5rem;">
            <div style="display:flex;align-items:center;gap:0.5rem;">
              <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}" style="width:28px;height:28px;border:1px solid var(--color-border);border-radius:50%;font-size:1rem;display:flex;align-items:center;justify-content:center;">−</button>
              <span style="font-size:0.9rem;font-weight:600;min-width:20px;text-align:center;">${item.quantity}</span>
              <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}" style="width:28px;height:28px;border:1px solid var(--color-border);border-radius:50%;font-size:1rem;display:flex;align-items:center;justify-content:center;">+</button>
            </div>
            <span style="font-weight:700;color:var(--color-primary);">${formatMoney(item.line_price)}</span>
          </div>
        </div>
      </div>
    `).join('');

    // Subtotal
    cartBody.innerHTML += `
      <div style="padding-top:1rem;border-top:2px solid var(--color-border);">
        <div style="display:flex;justify-content:space-between;margin-bottom:0.5rem;">
          <span style="font-weight:600;">Subtotal</span>
          <strong style="color:var(--color-primary);font-size:1.1rem;">${formatMoney(cart.total_price)}</strong>
        </div>
        <p style="font-size:0.78rem;color:var(--color-text-muted);margin-bottom:1rem;">Taxes and shipping calculated at checkout</p>
      </div>
    `;

    // Bind qty buttons
    cartBody.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty, 10);
        await updateLineItem(key, qty);
      });
    });
  }

  async function updateLineItem(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await res.json();
      updateCartUI(cart);
    } catch (err) {
      console.warn('Cart update error:', err);
    }
  }

  /* ── Add to Cart ── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.product-card__add-btn');
    if (!btn) return;
    e.preventDefault();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.textContent = 'Adding…';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!res.ok) throw new Error();
      btn.textContent = '✓ Added!';
      await refreshCart();
      openCart();
    } catch {
      btn.textContent = 'Error — Try Again';
    } finally {
      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }, 2500);
    }
  });



  /* ── Cart page quantity controls ── */
  document.querySelectorAll('.cart-page .qty-dec, .cart-page .qty-inc').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrap = btn.closest('.product-form__qty-wrap');
      const input = wrap ? wrap.querySelector('input[type="number"]') : null;
      if (!input) return;
      const current = parseInt(input.value || '0', 10);
      if (btn.classList.contains('qty-inc')) input.value = current + 1;
      if (btn.classList.contains('qty-dec')) input.value = Math.max(0, current - 1);
    });
  });

  /* ── Keyboard close modals ── */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeSearch();
      closeCart();
    }
  });

  /* ── Helpers ── */
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.theme && window.theme.currency) || 'AUD' });
  }

  /* ── Intersection Observer animations ── */
  if ('IntersectionObserver' in window) {
    const elements = document.querySelectorAll('.product-card, .testimonial-card, .features-bar__item, .image-with-text__media, .image-with-text__content');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animation = 'fadeUp 0.6s ease both';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    elements.forEach(el => {
      el.style.opacity = '0';
      observer.observe(el);
    });
  }

  /* ── Init ── */
  refreshCart();

})();
